<div class="winols-row analytics-card-host" [class.is-refreshing]="isLoading()">
  <!-- Left Card: Top Buyers -->
  <div class="winols-card">
    <div class="card-header">
      <h3>WinOLS Solutions - Top Buyers</h3>
    </div>

    <div class="card-body">
      <table class="buyers-table" *ngIf="topBuyers.length > 0">
        <thead>
          <tr>
            <th>Customer</th>
            <th class="text-right">Orders</th>
            <th class="text-right">Credits</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let buyer of topBuyers; let i = index">
            <td>
              <div class="customer-info">
                <div class="rank-badge">{{ i + 1 }}</div>
                <div class="customer-details">
                  <span class="customer-name">{{ buyer.name }}</span>
                  <span class="customer-email">{{ buyer.email }}</span>
                </div>
              </div>
            </td>
            <td class="text-right orders-value">{{ buyer.totalOrders | number }}</td>
            <td class="text-right credits-value">{{ buyer.totalRevenue | number:'1.0-0' }} Cr</td>
          </tr>
        </tbody>
      </table>

      <div class="empty-state" *ngIf="!isLoading() && topBuyers.length === 0">
        <span class="empty-text">No buyer data available</span>
      </div>
    </div>
  </div>

  <!-- Right Card: Credits Trend -->
  <div class="winols-card">
    <div class="card-header trend-header">
      <h3>WinOLS Solutions - Credits Trend</h3>
      <div class="granularity-toggle">
        <button [class.active]="granularity() === 'DAY'" (click)="onGranularityChange('DAY')">Day</button>
        <button [class.active]="granularity() === 'WEEK'" (click)="onGranularityChange('WEEK')">Week</button>
        <button [class.active]="granularity() === 'MONTH'" (click)="onGranularityChange('MONTH')">Month</button>
      </div>
    </div>

    <div class="card-body">
      <div class="chart-container" *ngIf="chartData.length > 0">
        <ngx-charts-bar-vertical
          [results]="chartData"
          [scheme]="colorScheme"
          [xAxis]="true"
          [yAxis]="true"
          [showXAxisLabel]="false"
          [showYAxisLabel]="false"
          [gradient]="true"
          [roundDomains]="true"
          [roundEdges]="true">
        </ngx-charts-bar-vertical>
      </div>

      <div class="empty-state" *ngIf="!isLoading() && chartData.length === 0">
        <span class="empty-text">No trend data available</span>
      </div>

      <div class="totals-row" *ngIf="chartData.length > 0">
        <div class="total-item">
          <span class="total-label">Total Credits</span>
          <span class="total-value total-credits">{{ totalCredits | number:'1.0-0' }} Cr</span>
        </div>
        <div class="total-item">
          <span class="total-label">Total Orders</span>
          <span class="total-value total-orders">{{ totalOrders | number }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
